<script setup>
import { defineAsyncComponent } from 'vue'

const props = defineProps({
  icon: {
    type: String,
    required: true,
  },
  size: {
    type: String,
    default: 'medium',
    validator (value) {
      return ['smallest', 'small', 'medium', 'large', 'larger', 'largest'].includes(value)
    },
  },
  isHoverable: {
    type: Boolean,
    default: false,
  },
})

const sizes = {
  smallest: 16,
  small: 20,
  medium: 24,
  large: 32,
  larger: 48,
  largest: 64,
}

const [origin, ...icon] = props.icon.includes(':') ? props.icon.split(':') : ['base', props.icon]

const IconComponent = defineAsyncComponent(() => import(`../../assets/icons/${origin}/${icon.join(':')}.svg`).catch(err => console.error(err)))
</script>

<template>
  <component
    :is="IconComponent"
    class="base-icon"
    :class="[
      `base-icon--${props.size}`,
      { 'base-icon--hoverable': props.isHoverable },
    ]"
    :width="sizes[props.size]"
    :height="sizes[props.size]"
  />
</template>

<style lang="scss">
.base-icon {
  container: base-icon / size;

  > * {
    stroke-width: 1;

    // https://www.w3.org/TR/SVGTiny12/painting.html#NonScalingStroke
    vector-effect: non-scaling-stroke;

    @container base-icon (min-width: 20px) {
      stroke-width: 1.25;
    }

    @container base-icon (min-width: 24px) {
      stroke-width: 1.5;
    }
  }

  &--hoverable {
    transition: $transition-duration-slowest;

    border-radius: $border-radius-circular;

    background-color: transparent;

    &:hover {
      @media (hover: hover) {
        transition: $transition-duration-slowest;

        background-color: $color-opacities-dark;
        cursor: pointer;
      }
    }
  }
}
</style>
